import {
  IAMAccountIdentity,
  iamAccountIdentity
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountCreateRequestDTORaw) {
    JsonSchemaValidator.validate(IAMAccountCreateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["identity"],
      properties: {
        identity: iamAccountIdentity
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCreateRequestDTORaw {
  identity: IAMAccountIdentity;
}
